<template>
  <div class="workshop-enroll">
    <img class="workshop-enroll-bg" :src="$getImgUrl('/site-images/activity/workshop-enroll/choiceLoginBg.png')">
    <div class="activity-name">
      (苏州康众专场报名)
    </div>
    <img class="vip" src="../../assets/images/activity/workshop/VIP.png" @click="toEnprll('vip')">
    <img class="noVip" src="../../assets/images/activity/workshop/noVIP.png" @click="toEnprll('noVip')">
  </div>
</template>

<script>
// import activityApi from '../../api/activity'
import { userUtils } from '@/utils/auth'
// import { commonUtils } from '@/utils/common'

export default {
  data () {
    return {
    }
  },

  computed: {
  },

  created () {
    this.clientInfo = userUtils.getClientInfo()
    // if (!this.clientInfo) {
    //   window.location.href = commonUtils.getExtraSite() + '/#/login'
    // }
    console.log(this.$route.query.fromSource)
  },
  methods: {
    // 跳转
    toEnprll (type) {
      if (type === 'noVip' && this.clientInfo !== null) {
        this.$dialog.alert({ message: '检测到您已登录，将跳转易加会员报名' })
          .then(() => {
            this.$router.push({ name: 'activity-workshop-login', query: { type: 'vip', fromSource: this.$route.query.fromSource } })
          })
      } else {
        this.$router.push({ name: 'activity-workshop-login', query: { type: type, fromSource: this.$route.query.fromSource } })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.workshop-enroll {
  position: relative;
}
.activity-name{
  position: absolute;
  width: 100%;
  text-align: center;
  top: 510px;
  text-align: center;
  color: rgb(133, 133, 133);
}
.workshop-enroll .workshop-enroll-bg{
  width: 375px;
  height: auto;
}
.workshop-enroll .vip{
  position: absolute;
  width: 260px;
  height: auto;
  top: 550px;
  left: 50%;
  margin-left: -130px;
}
.workshop-enroll .noVip{
  position: absolute;
  width: 260px;
  height: auto;
  top: 600px;
  left: 50%;
  margin-left: -130px;
}
</style>
